import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { AuthGuard } from 'src/auth/guard';
import DashboardLayout from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

// CLIENT
const PassportListPage = lazy(() => import('src/pages/procedure/passport/list'));
const PassportDetailsPage = lazy(() => import('src/pages/procedure/passport/details'));
const PassportNew = lazy(() => import('src/pages/procedure/passport/new'));
const PassportEditPage = lazy(() => import('src/pages/procedure/passport/edit'));
const PassportPhotoProcessingPage = lazy(() => import('src/pages/procedure/passport/photo-processing'));
// EMPLOYEE
const MigrationListPage = lazy(() => import('src/pages/procedure/migration/list'));
const MigrationDetailsPage = lazy(() => import('src/pages/procedure/migration/details'));
const MigrationNew = lazy(() => import('src/pages/procedure/migration/new'));
const MigrationEditPage = lazy(() => import('src/pages/procedure/migration/edit'));
// REMITTANCE
const RemittanceListPage = lazy(() => import('src/pages/procedure/remittance/list'));
const RemittanceNew = lazy(() => import('src/pages/procedure/remittance/new'));
const RemittanceEditPage = lazy(() => import('src/pages/procedure/remittance/edit'));
const RemittanceDetailsPage = lazy(() => import('src/pages/procedure/remittance/details'));
// ----------------------------------------------------------------------

export const procedureRoutes = [
  {
    path: 'procedure',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      {
        path: 'passport',
        children: [
          { element: <PassportListPage />, index: true },
          { path: 'list', element: <PassportListPage /> },
          { path: 'new', element: <PassportNew /> },
          { path: 'photo-processing', element: <PassportPhotoProcessingPage /> },
          { path: ':clientId/client', element: <PassportNew /> },
          { path: ':id/edit', element: <PassportEditPage /> },
          { path: ':id', element: <PassportDetailsPage /> },
        ],
      },
      {
        path: 'migration',
        children: [
          { element: <MigrationListPage />, index: true },
          { path: 'list', element: <MigrationListPage /> },
          { path: 'new', element: <MigrationNew /> },
          { path: ':clientId/client', element: <MigrationNew /> },
          { path: ':id/edit', element: <MigrationEditPage /> },
          { path: ':id', element: <MigrationDetailsPage /> },
        ],
      },
      {
        path: 'remittance',
        children: [
          { element: <RemittanceListPage />, index: true },
          { path: 'list', element: <RemittanceListPage /> },
          { path: 'new', element: <RemittanceNew /> },
          { path: ':clientId/client', element: <RemittanceNew /> },
          { path: ':clientId/client/:recipientId/recipient', element: <RemittanceNew /> },
          { path: ':id/edit', element: <RemittanceEditPage /> },
          { path: ':id', element: <RemittanceDetailsPage /> },
        ],
      },
    ],
  },
];
